<div *ngIf="!deviceInfo.IsMobile()">
    <div class="ui menu margin-top-50 margin-bottom-0">
        <div class="item name-input">
            <div class="ui icon input">
                <input id="name" type="text" placeholder="Nom">
                <i class="search icon"></i>
            </div>
        </div>
        <div class="ui pointing dropdown link item" suiDropdown>
            <span class="text">{{brandFilterComponent.selectedValue}}</span>
            <i class="dropdown icon"></i>
            <div class="menu" suiDropdownMenu>
                <div *ngFor="let brand of brandFilterComponent.values" class="item"
                     (click)="brandFilterComponent.valueSelected(brand)">{{brand}}
                </div>
            </div>
        </div>

        <div class="ui pointing dropdown link item" suiDropdown>
            <span class="text">{{gasolineFilterComponent.selectedValue}}</span>
            <i class="dropdown icon"></i>
            <div class="menu" suiDropdownMenu>
                <div *ngFor="let gasoline of gasolineFilterComponent.values" class="item"
                     (click)="gasolineFilterComponent.valueSelected(gasoline)">{{gasoline}}
                </div>
            </div>
        </div>

        <div class="ui pointing dropdown link item" suiDropdown>
            <span class="text">{{gearboxFilterComponent.selectedValue}}</span>
            <i class="dropdown icon"></i>
            <div class="menu" suiDropdownMenu>
                <div *ngFor="let gearbox of gearboxFilterComponent.values" class="item"
                     (click)="gearboxFilterComponent.valueSelected(gearbox)">{{gearbox}}
                </div>
            </div>
        </div>

        <div class="right item">
            <button class="ui primary flat padding-left-40 padding-right-40 button margin-left-50 margin-right-50"
                    (click)="updateFilters()">Filtrer</button>
        </div>
    </div>
    <div class="ui menu margin-bottom-30 margin-top-0">
        <div class="item">
            <div id="price-div-min" class="ui icon input fix-width">
                <input id="price-min" type="number" placeholder="Prix min">
                <i class="euro sign icon"></i>
            </div>
        </div>

        <div class="item">
            <div id="price-div-max" class="ui icon input fix-width">
                <input id="price-max" type="number" placeholder="Prix max">
                <i class="euro sign icon"></i>
            </div>
        </div>
        <div class="item">
            <div id="mileage-div-min" class="ui icon input fix-width">
                <input id="mileage-min" type="number" placeholder="Km min">
                <i class="car icon"></i>
            </div>
        </div>

        <div class="item">
            <div id="mileage-div-max" class="ui icon input fix-width">
                <input id="mileage-max" type="number" placeholder="Km max">
                <i class="car icon"></i>
            </div>
        </div>

        <div class="right item">
            <span class="sort">Tri</span>
            <button id="price-soring-button" class="ui primary button margin-left-40 margin-right-10 filter-input" (click)="sortingPriceClicked()">
                <i class="euro sign icon"></i>
                {{occasionsSorting.PriceSorting() == 0 ? "Aucun" :
                  occasionsSorting.PriceSorting() == 1 ? "Croissant" : "Décroissant"}}
            </button>
            <button id="mileage-soring-button" class="ui primary button margin-right-50 filter-input" (click)="sortingMileageClicked()">
                <i class="car icon"></i>
                {{occasionsSorting.MileageSorting() == 0 ? "Aucun" :
                  occasionsSorting.MileageSorting() == 1 ? "Croissant" : "Décroissant"}}
            </button>
        </div>
    </div>
</div>

<div *ngIf="deviceInfo.IsMobile()">
    <div class="margin-bottom-10 margin-top-0">
        <div class="sorting-mobile ui stackable grid">
            <div class="column">
                <button id="price-soring-button" class="ui primary button" (click)="sortingPriceClicked()">
                    <i class="euro sign icon"></i>
                    {{occasionsSorting.PriceSorting() == 0 ? "Aucun" :
                    occasionsSorting.PriceSorting() == 1 ? "Croissant" : "Décroissant"}}
                </button>
            </div>

            <div class="column">
                <button id="mileage-soring-button" class="ui primary button" (click)="sortingMileageClicked()">
                    <i class="car icon"></i>
                    {{occasionsSorting.MileageSorting() == 0 ? "Aucun" :
                    occasionsSorting.MileageSorting() == 1 ? "Croissant" : "Décroissant"}}
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-filter/occasions-filter.html